/**
 * Role detection from the verified Auth0 ID token claims (Auth0 is the only
 * identity provider). This is display logic only: every server-side action
 * must re-verify the token and its roles independently.
 */
export const AUTH0_ROLES_CLAIM = "https://foreign-council.org/roles";

export const ADMIN_ROLES = ["global_administrator", "country_administrator"] as const;

function normalize(role: string): string {
  return role.trim().toLowerCase().replace(/\s+/g, "_");
}

export function rolesFromClaims(claims: Record<string, unknown> | null | undefined): string[] {
  const raw = claims?.[AUTH0_ROLES_CLAIM];
  if (!Array.isArray(raw)) return [];
  return raw.filter((r): r is string => typeof r === "string").map(normalize);
}

export function isEventAdmin(roles: readonly string[]): boolean {
  return roles.some((r) => (ADMIN_ROLES as readonly string[]).includes(r));
}
